import React from 'react';
import cx from 'classnames';

import {
  Container,
  Grid,
  GridCol,
  Icon,
  Section,
  Button,
  TextContainer,
  Bar,
  BarItem,
} from '../../components';

import Newsletter from '../../modules/Newsletter';
import GDPR from '../../modules/GDPR';
import CompanyPolicy from '../../modules/CompanyPolicy';
import FooterEasterEgg from '../../modules/FooterEasterEgg';

import data from '../../data/components/footer';
import getData, { getString } from '../../scripts/lib/dataHandling';

import {
  propTypes as langPropTypes,
  defaultProps as langDefaultProps,
} from '../../data/lang';

const propTypes = langPropTypes;
const defaultProps = langDefaultProps;

const CLASS_ROOT = 'footer';

const Footer = ({ className, children, lang, ...other }) => {
  const classes = cx(CLASS_ROOT, className);
  const creationYear = 2019;
  const thisYear = new Date().getFullYear();

  const socials = getData(data, 'foot.socials', 'sk');

  const email = (
    <a
      href={`mailto:${getData(data, 'foot.email.value', lang)}`}
      className="h5 text-color-white"
    >
      {getData(data, 'foot.email.value', lang)}
    </a>
  );

  const phone = (
    <a
      href={`tel:${getData(data, 'foot.phone.formatted', lang).replace(
        /\s/gi,
        ''
      )}`}
      className="h5 text-color-white"
    >
      {getData(data, 'foot.phone.formatted', lang)}
    </a>
  );

  return (
    <footer className={classes} {...other}>
      <Section id="contact" color="black" space="none">
        <Container>
          <Section space="xlarge" className="border-bottom border-dark-grey">
            <Grid>
              <GridCol
                size={{ m: 18, l: 'auto' }}
                offset={{ xs: 'center', l: 6 }}
                className="pl-l-none"
              >
                <TextContainer size="wide">
                  <p className="h4 text-color-white font-family-clearface text-normal mb">
                    {getString(data, 'invitation.text', lang)}
                  </p>
                  <Button
                    padded
                    className="border border-white"
                    color="white"
                    href={getData(data, 'invitation.button.link', lang)}
                  >
                    {getString(data, 'invitation.button.text', lang)}
                  </Button>
                </TextContainer>
              </GridCol>
            </Grid>
          </Section>
          <Newsletter />
          <Section spaceBottom="small">
            <Grid>
              <GridCol size={{ xs: 'auto', m: 6 }} className="mb-small" />
              <GridCol
                size={{ xs: 'auto', m: 'fixed', l: 6 }}
                className="pl-l-none mb-small"
              >
                <div className="text-right hide-m">{email}</div>
                <div className="show-m">{email}</div>
              </GridCol>
              <GridCol size={{ m: 'fixed', l: 6 }} className="mb">
                <div className="text-right hide-m">{phone}</div>
                <div className="show-m">{phone}</div>
              </GridCol>
              <GridCol size={{ m: 'auto' }}>
                <Grid className="align-items-right">
                  <GridCol size="fixed">
                    <Bar
                      space={{ xs: 'xsmall', l: 'small' }}
                      className="mb-none"
                      nowrap
                    >
                      {socials.map(({ title, link, icon }) => (
                        <BarItem className="mt-none" key={link}>
                          <Button
                            size="small"
                            equal
                            color="white"
                            title={title}
                            aria-label={title}
                            href={link}
                            target="_blank"
                          >
                            <Icon name={icon} size="small" />
                          </Button>
                        </BarItem>
                      ))}
                    </Bar>
                  </GridCol>
                </Grid>
              </GridCol>
            </Grid>
          </Section>
          <Grid className="align-items-right">
            <GridCol size="fixed">
              <GDPR />
            </GridCol>
            <GridCol size="fixed">
              <CompanyPolicy />
            </GridCol>
            <GridCol size="fixed">
              <p className="text-color-grey mb-small text-small">
                ©{creationYear}
                {thisYear > creationYear && ` - ${thisYear}`} Lighting Beetle
                s.r.o.
              </p>
            </GridCol>
          </Grid>
          <Section space="small">
            <Grid>
              <GridCol>
                <FooterEasterEgg />
              </GridCol>
            </Grid>
          </Section>
        </Container>
      </Section>
    </footer>
  );
};

Footer.propTypes = propTypes;
Footer.defaultProps = defaultProps;
Footer.displayName = 'Footer';

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js